import { Navigate } from 'react-router-dom';
import { LoadingOverlay } from '@/components/core';
import { OnboardingWizard } from '../components/onboarding-wizard';
import { useMyOgnization } from '@/api-client/use-my-ognization';
import { useMe } from '@/api-client/use-me';
import { useMyOgnizationStore, useUserStore } from '@/store';
import { useGetUserProfiles } from '@/graphql';


export function OnboardingPage() {
  const { isLoading: isOrgsLoading } = useMyOgnization();
  const { data: profile, isLoading: isProfileLoading } = useMe();
  const { user: userData } = useUserStore();
  const currentOrganization = useMyOgnizationStore((state) => state.currentOrganization);
  const organizations = useMyOgnizationStore((state) => state.organization?.organizations);
  const listedOrg = organizations?.find((org) => org.itemId === currentOrganization?.itemId)
    ?? organizations?.[0];
  const orgId = currentOrganization?.itemId || listedOrg?.itemId;
  const orgName = listedOrg?.name || currentOrganization?.name;
  const userId = profile?.itemId ?? userData?.itemId;
  const { data, isLoading: isUserProfileLoading } = useGetUserProfiles({
    where: userId ? { BlocksUserId: { eq: userId } } : {},
    paging: { pageNo: 1, pageSize: 1 },
  });
  const userProfile = data?.getUserProfiless?.items?.[0];

  if (isOrgsLoading || isProfileLoading || (!!userId && isUserProfileLoading)) {
    return <LoadingOverlay />;
  }

  if (userProfile?.OnboardingCompleted === true) {
    return <Navigate to="/org/select" replace />;
  }

  const stepsCompleted = (userProfile?.OnboardingStepsCompleted ?? []).filter(
    (step): step is string => typeof step === 'string'
  );

  return (
    <div className="mx-auto max-w-3xl px-4 py-8 sm:px-6 lg:px-8">
      <OnboardingWizard
        orgRole={profile?.roles[0]}
        orgSlug={orgId}
        orgName={orgName}
        orgId={orgId}
        initialProfile={{
          firstName: userData?.firstName,
          lastName: userData?.lastName,
          imageUrl: userData?.profileImageUrl,
          jobTitle: userProfile?.JobTitle ?? userData?.salutation ?? null,
          department: userProfile?.Department ?? userData?.attributes?.department,
        }}
        stepsCompleted={stepsCompleted}
      />
    </div>
  );
}
